import { Builder } from '@builder.io/react'
import React from 'react'
import './slider.css'
import Slider from 'react-slick'

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'

interface Image {
  // cloudinaryImage: any
  builderImage: any
  imgAltText: string
}
interface Props {
  backgroundColor: string
  foodImages: Image[]
  showArrow: boolean
}

function SampleNextArrow(props: any) {
  const { className, style, onClick } = props
  return (
    <ChevronRightIcon onClick={onClick} className={`${className} slider-text-chevron-right h-2 sm:h-6`} style={style} />
  )
}

function SamplePrevArrow(props: any) {
  const { className, style, onClick } = props
  return (
    <ChevronLeftIcon onClick={onClick} className={`${className} slider-text-chevron-left h-2 sm:h-6`} style={style} />
  )
}

const SliderSection = ({ backgroundColor, foodImages }: Props) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false
  }

  const mobileSettings = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false
  }

  const getSlideItems = () => {
    return foodImages.map((item: Image, i: number) => {
      return (
        <div key={i} className="custom-slider-item w-full">
          <CdnImage
            className="slider-image object-cover"
            url={item.builderImage}
            alt={item.imgAltText}
            steps={[100, 200, 400]}
          />
          {/* {item.builderImage ? (
            <CdnImage
              className="slider-image object-cover"
              url={item.builderImage}
              alt={item.imgAltText}
              steps={[100, 200, 400]}
            />
          ) : (
            <CloudinaryImage
              className="slider-image object-cover"
              publicId={item.cloudinaryImage?.public_id}
              loading={'eager'}
              alt={item.imgAltText}
              steps={[100, 200, 400]}
            />
          )} */}
        </div>
      )
    })
  }

  return (
    <>
      <div className="slider-text hidden lg:block" style={{ backgroundColor: backgroundColor || '#ffffff' }}>
        <div className="slider-text-container mx-auto gap-8 py-4 px-0 sm:grid-cols-1 sm:px-2 md:grid-cols-2">
          <div className="relative w-full">
            <div className="w-full justify-center">
              <Slider {...settings} className="slider-text-container-slider relative mx-auto">
                {getSlideItems()}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <div className="slider-text block lg:hidden" style={{ backgroundColor: backgroundColor || '#ffffff' }}>
        <div className="slider-text-container mx-auto gap-8 px-0 sm:grid-cols-1 sm:px-2 md:grid-cols-2 lg:px-4">
          <div className="relative w-full">
            <div className="w-full justify-center">
              <Slider {...mobileSettings} className="slider-text-container-slider relative mx-auto">
                {getSlideItems()}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SliderSection

Builder.registerComponent(SliderSection, {
  name: 'SliderSection',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#f9f5f1'
    },
    {
      name: 'foodImages',
      type: 'list',
      defaultValue: [
        {
          imgSrc: null,
          imgAltText: ''
        }
      ],
      subFields: [
        // {
        //   name: 'cloudinaryImage',
        //   type: 'cloudinaryImageEditor'
        // },
        {
          name: 'builderImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },
        {
          name: 'imgAltText',
          type: 'text',
          defaultValue: ''
        }
      ]
    },
    {
      name: 'showArrow',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
